import { Channel } from "core/codegen/types";
export var typenameToVariant = function (type) {
    switch (type) {
        case "MarketingBannerVtmGo":
            return "VTM Go";
        default:
            return "VTM";
    }
};
export var getChannelForLogo = function (banner) {
    if (banner.__typename === "MarketingBannerVtmGo")
        return "VTMGOPLUS";
    if (banner.__typename === "MarketingBannerNews")
        return Channel.News;
    if (banner.channel)
        return banner.channel;
    return undefined;
};
export var getLink = function (banner) {
    if (!banner.cta || !banner.cta.link)
        return undefined;
    return banner.cta.link.url;
};
export var hexToRgb = function (hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var rgbaArray = result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
    if (!rgbaArray)
        return "0,0,0";
    return rgbaArray.r + ',' + rgbaArray.g + ',' + rgbaArray.b;
};
